/***
 * Created on 2023/8/23
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";

function InitAuthAppSetup({dispatch, ..._props}) {
    const { t } = useTranslation();

    const onClick = (e) => {
        e.preventDefault();
        dispatch({type: 'toggleShowInitSMSSetup', value: true});
    }

    const onVerify = (e) => {
        e.preventDefault();
        dispatch({type: 'toggleShowAuthAppSetup', value: true})
    }

    return (
        <ModalDialog {..._props} title={t('@Setup 2-Step Verification@')} hideSubmit={true}>
            <div className="dialog-content">
                <div className="dialog__info-grid">
                    <div className="info-grid__row flex-direction-column !flex-wrap-wrap pt-16 pr-24 pb-24 pl-24">
                        <div className="dialog__sub-title color-primary display-flex align-items-center">
                            <div className="mr-10">{t('@Verify via App@')}</div>
                            <div className="comp-tag">
                                <div className="q-tag q-tag--tiny q-tag--recommend">
                                    <span className="tag__label">{t('@Recommend@')}</span>
                                </div>
                            </div>
                        </div>
                        <p>{t('@Most secure option available to receive verification code. As many of the apps on your mobile device may have permission to access your SMS and see your codes. Authenticator app works even better when you are out of network coverage area and internet connectivity for your mobile.@')}</p>
                        <button className="q-btn q-btn--primary btn-rounded-full !w-fit" onClick={onVerify}>{t('@Verify@')}</button>
                    </div>
                </div>
                <p>or <a href="#" onClick={onClick}>{t('@Verify via SMS@')}</a></p>
            </div>
        </ModalDialog>
    );
}

export default InitAuthAppSetup;